import React from 'react'
import { Toast } from 'react-bootstrap';

const ToastComponent = ({message, close}) =>{

    const onClose = () =>{
        close('');
    }

    return (
        <Toast onClose={()=>onClose()} show={message} delay={5000} autohide style={{position:'absolute', bottom: 10, right:30}} className='bg-dark text-white shadow'>
            <Toast.Header close className='d-flex'><div className='flex-fill'>Message</div></Toast.Header>
            <Toast.Body>
                {message}
            </Toast.Body>
        </Toast>
    )

}

export default ToastComponent;